import { VesselDetailModel, ClassSocietyClientModel, VesselClassHistoryChange } from "../../../../../models/vessels/vessel.models";
import { PropertyChangeNotifier } from "../../../../../models/basics/basics.models";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { transient, autoinject, computedFrom } from "aurelia-framework";
import { CloneHelper } from "@rightship-tech/common-ui/helpers/clone.helper";
import { DataStewardClientService } from "../../../../../services/modules/data-steward-client.service";
import { ManageVesselService } from "../../../../../services/vessels/manage-vessel.service";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import * as Enumerable from "linq";
import { DateHelper } from "../../../../../utilities/date-helper";
import * as moment from "moment";
import { Reflection } from "../../../../../utilities/reflection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@transient()
@autoinject()
export class EditVesselClassesDialog {

    public classSocieties: ClassSocietyClientModel[] = [];
    public classSocietiesNotifier = new PropertyChangeNotifier();
    public vessel: VesselDetailModel;
    public items: VesselClassHistoryChange[];
    public isShowingHistory: boolean;
    public loading: boolean = true;
    public disabled: boolean;

    @computedFrom(Reflection.getPropertyPath<EditVesselClassesDialog>(z => z.classSocieties), Reflection.getPropertyPath<EditVesselClassesDialog>(z => z.classSocieties.length))
    get excludedClassSocieties() {
        return this.classSocieties.map(x => x.classId);
    }

    constructor(private dataStewardClientService: DataStewardClientService,
        private dialogClientService: DialogClientService,
        private vesselService : ManageVesselService,
        private userClaimsService: UserClaimsService) {
        this.disabled = !this.userClaimsService.hasPermission(Claims.EditVesselDetails);
    }

    activate(model: { vessel: VesselDetailModel }) {
        this.vessel = model.vessel;
        this.classSocieties = CloneHelper.clone(model.vessel.classSocieties) ?? [];
    }

    async attached() {
        const response = await this.vesselService.getClassSocietiesHistories(this.vessel.vesselId);
        this.items = Enumerable.from(response.vesselClassHistoryChanges).select(item => {
            item.date = moment.utc(item.date).format('YYYY-MM-DD');

            return item;
        }).orderByDescending(z => DateHelper.castDate(z.date)).toArray();
        

        this.loading = false;
    }

    removeClass(index: number) {
        if (index > -1) {
            this.classSocieties.splice(index, 1);
        }
        this.classSocietiesNotifier.trigger();
    }

    addClass() {
        if(!this.classSocieties) {
            return 
        }

        const item = {
            classCode: null,
            classHistoryId: null,
            classId: null,
            className: null,
            classUrl: null
        };
        this.classSocieties.push(item);
    }

    onClassificationSocietyChanged() {
        this.classSocietiesNotifier.trigger();
    }

    cancel() {
        this.dialogClientService.hide();
    }

    async save() {

        await this.dataStewardClientService.pushOverriddenValue(this.vessel.vesselId, EntityTypes.Vessel, [{
            propertyName: "ClassSocieties",
            overriddenValue: this.classSocieties.filter(x => x.classId && x.classId > 0).map(x => x.classId).join(","),
            sourceComment: ""
        }]);
        this.dialogClientService.hide();

    }

    async showHistory() {
        this.isShowingHistory = !this.isShowingHistory;
    }

    castBooleanValue(value: boolean) {
        return value == true ? "Yes" : "No";
    }
}